"use client";
import { useState as d, useEffect as m } from "react";
import { getViewport as p } from "./index29.js";
import { useWindowSize as h } from "./index14.js";
function M(t) {
  const { width: n } = h(), [x, u] = d("xs");
  return m(() => {
    if (n > 0) {
      let e = p(n);
      if (t && t.length > 0 && !t.includes(e)) {
        const o = [
          "xs",
          "s",
          "m",
          "l",
          "xl",
          "xxl"
        ], r = o.indexOf(e);
        let s = t[0], f = Math.abs(
          o.indexOf(s) - r
        );
        for (const i of t) {
          const c = Math.abs(o.indexOf(i) - r);
          c < f && (f = c, s = i);
        }
        e = s;
      }
      u(e);
    }
  }, [n, t]), x;
}
export {
  M as useViewport
};
